var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.6055 48.8028C70.6055 60.8444 60.8444 70.6055 48.8028 70.6055C36.7611 70.6055 27 60.8444 27 48.8028C27 36.7611 36.7611 27 48.8028 27C60.8444 27 70.6055 36.7611 70.6055 48.8028Z",
    stroke: "#3958A5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8028 62.9745C52.5614 62.9745 56.1661 61.4814 58.8238 58.8237C61.4815 56.166 62.9746 52.5613 62.9746 48.8027C62.9746 45.0441 61.4815 41.4395 58.8238 38.7817C56.1661 36.124 52.5614 34.6309 48.8028 34.6309M48.8028 62.9745C45.0442 62.9745 41.4396 61.4814 38.7819 58.8237C36.1241 56.166 34.631 52.5613 34.631 48.8027C34.631 45.0441 36.1241 41.4395 38.7819 38.7817C41.4396 36.124 45.0442 34.6309 48.8028 34.6309M48.8028 62.9745V52.0731M48.8028 34.6309V45.5323M61.0778 41.7168L51.6372 47.1675M45.9707 50.4379L36.5301 55.8886M61.0778 55.8886L51.6372 50.4379M45.9707 47.1675L36.5301 41.7168",
    stroke: "#3958A5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0732 48.8028C52.0732 49.6701 51.7287 50.502 51.1154 51.1153C50.502 51.7286 49.6702 52.0732 48.8028 52.0732C47.9355 52.0732 47.1036 51.7286 46.4903 51.1153C45.877 50.502 45.5324 49.6701 45.5324 48.8028C45.5324 47.9354 45.877 47.1036 46.4903 46.4902C47.1036 45.8769 47.9355 45.5323 48.8028 45.5323C49.6702 45.5323 50.502 45.8769 51.1154 46.4902C51.7287 47.1036 52.0732 47.9354 52.0732 48.8028Z",
    stroke: "#3958A5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49 1.5C75.2335 1.5 96.5 22.7665 96.5 49C96.5 75.2335 75.2335 96.5 49 96.5C22.7665 96.5 1.5 75.2335 1.5 49C1.5 22.7665 22.7665 1.5 49 1.5Z",
    stroke: "#3958A5",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFour);
export default __webpack_public_path__ + "static/media/icon-four.6af331da74d6b3c30c07eb78eee4e80e.svg";
export { ForwardRef as ReactComponent };